import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Wrapper from '../../../components/wrapper'
import { gotoRestaurantDetails, searchRestaurantsAsync, resetSearchRestaurants } from '../../../actions/restaurantSearch'
import PropTypes from 'prop-types'
import Loader from '../../../components/loader'
import * as Badges from '../../../components/badges'
import { Link } from 'react-router-dom'
import SearchInput from './searchInput'
import Pagination from '../../../components/pagination'

export class Restaurants extends React.Component {

  componentDidMount() {
    this.updateResultsToMatchQuery()
  }

  componentDidUpdate() {
    this.updateResultsToMatchQuery()
  }

  updateResultsToMatchQuery() {
    // no query string we should clear out the search so we do not
    // see previous search results
    if (!this.props.searchText || !this.props.searchType) {
      this.props.resetSearchRestaurants()
    }

    // if the values in our search results do not match what is 
    // in our query string we will perform the search
    else if (this.props.searchText !== this.props.resultSearchText
      || this.props.searchType !== this.props.resultSearchType
      || this.props.offset !== this.props.resultOffset) {
      this.props.searchRestaurantsAsync(this.props.searchText, this.props.searchType, this.props.offset)
    }

    // if we only have one result go straight to the restaurant page
    else if (this.props.resultRestaurants.length === 1) {
      this.props.gotoRestaurantDetails(this.props.resultRestaurants[0].id)
    }
  }

  renderSearchResultTable() {

    let statusTag = (status) => status === "Offline" ? <Badges.Offline />
      : status === "TempOffline" ? <Badges.TempOffline />
        : status === "Online" ? <Badges.Online />
          : <Badges.Unknown />

    const partnerSubscriptionsString = (subscriptions) => {
      if (!subscriptions || subscriptions.length === 0) return "-"
      return subscriptions.map(s => `${s.type || '-'}`).join(", ")
    }

    return <div>
      <table className="table table-striped">
        <thead>
          <tr className="codebox-title">
            <th>ID</th>
            <th>Restaurant Name</th>
            <th>Current Pool</th>
            <th>Subscriptions</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {this.props.resultRestaurants.map(r => (<tr key={r.id}>
            <td><Link to={'/restaurants/' + encodeURIComponent(r.id)}>{r.id}</Link></td>
            <td>{r.name}</td>
            <td>{r.pool ? <Link to={'/pools/' + encodeURIComponent(r.pool.id)}>{r.pool.name}</Link> : "No pool"}</td>
            <td>{partnerSubscriptionsString(r.partnerSubscriptions)}</td>
            <td>{statusTag(r.status)}</td>
          </tr>))}
        </tbody>
      </table>
    </div>
  }

  render() {
    let searchResults = null
    if (this.props.resultIsLoading) {
      searchResults = <Loader />
    }
    else if (!this.props.resultIsLoaded) {
      searchResults = null
    }
    else if (this.props.resultError) {
      searchResults = <div className="alert alert-danger">{this.props.resultError}</div>
    }
    else if (this.props.resultRestaurants.length === 0) {
      searchResults = <div className="alert alert-info">No Search Results</div>
    }
    else if (this.props.resultRestaurants.length > 0) {
      searchResults = this.renderSearchResultTable()
    }

    return <Wrapper title="Restaurants" >
      <SearchInput
        key={`${this.props.searchType}/${this.props.searchText}`}
        searchText={this.props.searchText}
        searchType={this.props.searchType} />
      {searchResults}
      <Pagination url={'/restaurants/search'} params={{ q: this.props.searchText, qt: this.props.searchType }} page={this.props.page} itemsPerPage={this.props.itemsPerPage} totalItems={this.props.totalItems} />
    </Wrapper>
  }
}

Restaurants.propTypes = {
  resultIsLoading: PropTypes.bool,
  resultIsLoaded: PropTypes.bool,
  resultRestaurants: PropTypes.array,
  resultError: PropTypes.string,
  resultSearchText: PropTypes.string,
  resultSearchType: PropTypes.string,
  resultOffset: PropTypes.number,
  resultTotalItems: PropTypes.number,

  searchText: PropTypes.string,
  searchType: PropTypes.string,
  page: PropTypes.number,
  offset: PropTypes.number,
  itemsPerPage: PropTypes.number,
  totalItems: PropTypes.number,

  searchRestaurantsAsync: PropTypes.func,
  resetSearchRestaurants: PropTypes.func,
  gotoRestaurantDetails: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  let page = parseInt(ownProps.page, 10) || 1

  return {
    resultIsLoading: state.restaurantSearch.isLoading,
    resultIsLoaded: state.restaurantSearch.isLoaded,
    resultRestaurants: state.restaurantSearch.data,
    resultError: state.restaurantSearch.error,
    resultSearchText: state.restaurantSearch.searchText,
    resultSearchType: state.restaurantSearch.searchType,
    resultOffset: state.restaurantSearch.offset,
    resultTotalItems: state.restaurantSearch.totalItems,
    totalItems: state.restaurantSearch.totalItems,
    itemsPerPage: state.restaurantSearch.itemsPerPage,
    offset: state.restaurantSearch.itemsPerPage * (page - 1),
    searchText: ownProps.searchText,
    searchType: ownProps.searchType,
    page
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  searchRestaurantsAsync,
  resetSearchRestaurants,

  gotoRestaurantDetails: gotoRestaurantDetails,
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Restaurants)



// WEBPACK FOOTER //
// ./src/containers/restaurants/search/index.js